export const INVITE_STATUSES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
} as const;

export type InviteStatus = typeof INVITE_STATUSES[keyof typeof INVITE_STATUSES];
